import {
  BookingState,
  ConversationStage,
  TherapistOption,
} from '../types/booking'
export const services = [
  { name: 'Swedish Massage', price: 77.25, duration: 60 },
  { name: 'Deep Tissue Massage', price: 85.0, duration: 60 },
  { name: 'Hot Stone Massage', price: 95.0, duration: 75 },
  { name: 'Facial Treatment', price: 68.0, duration: 60 },
  { name: 'Manicure', price: 35.0, duration: 45 },
  { name: 'Pedicure', price: 45.0, duration: 60 },
]
export const locations = [
  'Kensington',
  'Chelsea',
  'Notting Hill',
  'Mayfair',
  'Knightsbridge',
]
export const therapistsData = {
  Sarah: {
    bio: 'Certified massage therapist with 8+ years of experience specializing in Swedish and Deep Tissue techniques. Passionate about holistic wellness and helping clients achieve deep relaxation.',
    rating: 4.9,
    reviewCount: 127,
    specialties: ['Swedish Massage', 'Deep Tissue Massage'],
    imageUrl:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    reviews: [
      {
        customerName: 'Emma L.',
        rating: 5,
        comment:
          'Sarah is absolutely amazing! Best massage I have ever had. She really knows how to work out tension.',
        date: '2 days ago',
      },
      {
        customerName: 'Michael P.',
        rating: 5,
        comment:
          'Very professional and attentive. Sarah listened to my concerns and tailored the massage perfectly.',
        date: '1 week ago',
      },
      {
        customerName: 'Lisa K.',
        rating: 4,
        comment:
          'Great deep tissue massage. Sarah has strong hands and really gets into the knots.',
        date: '2 weeks ago',
      },
    ],
  },
  James: {
    bio: 'Expert in therapeutic massage with specialization in Hot Stone therapy. Trained in sports massage and injury rehabilitation with a focus on pain relief and recovery.',
    rating: 4.8,
    reviewCount: 94,
    specialties: ['Swedish Massage', 'Hot Stone Massage'],
    imageUrl:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    reviews: [
      {
        customerName: 'David R.',
        rating: 5,
        comment:
          'James is a true professional. His hot stone massage was incredibly relaxing and therapeutic.',
        date: '3 days ago',
      },
      {
        customerName: 'Sophie M.',
        rating: 5,
        comment:
          'Excellent technique and very knowledgeable. I felt so much better after the session.',
        date: '1 week ago',
      },
      {
        customerName: 'Tom H.',
        rating: 4,
        comment:
          'Good massage, James was friendly and made sure I was comfortable throughout.',
        date: '3 weeks ago',
      },
    ],
  },
}
export const getAvailableSlots = (
  service: string,
  location: string,
  date: string,
) => {
  return [
    { therapist: 'Sarah', times: ['2:00 PM', '3:30 PM', '5:00 PM'] },
    { therapist: 'James', times: ['1:00 PM', '4:00 PM'] },
  ]
}
export const getBotResponse = (
  stage: ConversationStage,
  userInput: string,
  bookingState: BookingState,
): {
  message: string
  options?: string[]
  therapists?: TherapistOption[]
  nextStage: ConversationStage
} => {
  switch (stage) {
    case 'greeting':
      return {
        message:
          "Welcome to Beautii! I'm here to help you book your perfect treatment. What service are you interested in today?",
        options: services.map((s) => s.name),
        nextStage: 'service',
      }
    case 'service':
      const selectedService = services.find(
        (s) => s.name.toLowerCase() === userInput.toLowerCase(),
      )
      if (selectedService) {
        return {
          message: `Great choice! A ${selectedService.name} is £${selectedService.price} for ${selectedService.duration} minutes. Which area would you like your treatment?`,
          options: locations,
          nextStage: 'location',
        }
      }
      return {
        message: "I'm sorry, I didn't catch that. Please select a service:",
        options: services.map((s) => s.name),
        nextStage: 'service',
      }
    case 'location':
      if (locations.some((l) => l.toLowerCase() === userInput.toLowerCase())) {
        return {
          message: `Perfect! When would you like your ${bookingState.service} in ${userInput}?`,
          options: ['Today', 'Tomorrow', 'This Weekend', 'Next Week'],
          nextStage: 'date',
        }
      }
      return {
        message: 'Please select one of our available locations:',
        options: locations,
        nextStage: 'location',
      }
    case 'date':
      const availableTherapists: TherapistOption[] = [
        {
          name: 'Sarah',
          time: '2:00 PM',
          ...therapistsData.Sarah,
        },
        {
          name: 'Sarah',
          time: '3:30 PM',
          ...therapistsData.Sarah,
        },
        {
          name: 'Sarah',
          time: '5:00 PM',
          ...therapistsData.Sarah,
        },
        {
          name: 'James',
          time: '1:00 PM',
          ...therapistsData.James,
        },
        {
          name: 'James',
          time: '4:00 PM',
          ...therapistsData.James,
        },
      ]
      return {
        message: `I found these available therapists for ${userInput.toLowerCase()} in ${bookingState.location}. Click on any therapist to view their profile, reviews, and book your appointment:`,
        therapists: availableTherapists,
        nextStage: 'therapist',
      }
    case 'therapist':
      const [therapist, time] = userInput.split(' - ')
      const service = services.find(
        (s) => s.name.toLowerCase() === bookingState.service?.toLowerCase(),
      )
      return {
        message: `Excellent! I've booked ${therapist} for a ${service?.duration}-minute ${bookingState.service} at ${time} ${bookingState.date?.toLowerCase()}.\n\nTotal: £${service?.price}\n\nHere's your payment link: [Stripe Payment Link]\n\nYou'll receive a confirmation once payment is complete. Is there anything else I can help you with?`,
        nextStage: 'complete',
      }
    case 'complete':
      return {
        message:
          'Thank you for choosing Beautii! Have a wonderful day and we look forward to seeing you soon! 💆‍♀️',
        nextStage: 'greeting',
      }
    default:
      return {
        message: "I'm here to help! What would you like to do?",
        nextStage: 'greeting',
      }
  }
}
